import { render, staticRenderFns } from "./historialPedidos.vue?vue&type=template&id=c791e874"
import script from "./historialPedidos.vue?vue&type=script&lang=js"
export * from "./historialPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports